import { ComponentPropsWithoutRef } from 'react'

import clsx from 'clsx'

import { ContentfulRichText } from '../../../common/ContentfulRichText'
import { useEntryField } from '../CaseStudy.hooks'

type BaseProps = {
	fieldPath?: string
	fontSize?: string
}

type Props = BaseProps & Omit<ComponentPropsWithoutRef<typeof ContentfulRichText>, 'field'>
export function CaseStudyRichText({ fieldPath, className, fontSize, ...rest }: Props) {
	const field = useEntryField({ fieldPath })

	return (
		<ContentfulRichText
			{...rest}
			field={field}
			className={clsx(
				className,
				'[&>p+.case-study-quote]:mt-15',
				fieldPath === 'quote' &&
					'[&>p:first-child]:text-xl [&>p:first-child]:font-medium [&>p:last-child]:text-[17px] [&>p:last-child]:font-semibold [&>p:last-child]:uppercase'
			)}
		/>
	)
}
